/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
import React from 'react';

/**
 * Hook used to deal with controlled and uncontrolled components when using form data handle.
 * @param {value: any, defaultValue: any} param
 */
const useControlled = _ref => {
  let {
    value: valueProp,
    defaultValue: defaultValueProp
  } = _ref;
  const {
    current: isControlled
  } = React.useRef(valueProp !== undefined);
  const [defaultValue, setDefaultValue] = React.useState(defaultValueProp);
  const value = isControlled ? valueProp : defaultValue;
  if (process.env.NODE_ENV !== 'production') {
    React.useEffect(() => {
      if (isControlled !== (valueProp !== undefined)) {
        console.error("Tangram: A component is changing the ".concat(isControlled ? 'controlled' : 'uncontrolled', " state to be ").concat(isControlled ? 'uncontrolled' : 'controlled', " component after being initialized.\n        To avoid it decide between using a controlled or uncontrolled."));
      }
    }, [valueProp]);
    React.useEffect(() => {
      if (!isControlled && defaultValue !== defaultValueProp) {
        console.error('Tangram: A component is changing of an uncontrolled to controlled component after being initialized. To avoid it use as a `controlled` component');
      }
    }, [JSON.stringify(defaultValueProp)]);
  }
  const setValue = React.useCallback(newValue => {
    if (!isControlled) {
      setDefaultValue(newValue);
    }
  }, [isControlled]);
  return [value, setValue];
};
export default useControlled;